import { createSlice } from '@reduxjs/toolkit';
import { IAbUseExperiment } from '../../types/abUseExperiments';

const initialState: IAbUseExperiment[] = [];

export const abUseExperimentsSlice = createSlice({
  name: 'abUseExperiments',
  initialState,
  reducers: {},
});

export const { reducer: abUseExperimentsReducer } = abUseExperimentsSlice;
